export default __webpack_public_path__ + "static/media/almendro.ee1f3283.jpg";